import { FormEvent, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Shell } from '../components/Shell';
import { useAuth } from '../lib/auth';

export function SignUpPage() {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const { sendLink } = useAuth();
  const navigate = useNavigate();

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (!email || submitting) return;
    setError('');
    setSubmitting(true);
    try {
      await sendLink(email.trim());
      navigate(`/signup/sent?email=${encodeURIComponent(email.trim())}`);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Could not send the link');
      setSubmitting(false);
    }
  };

  return (
    <Shell centerLabel="Sign up · Step 1 of 4">
      <section className="border-b" style={{ borderColor: 'var(--rule)' }}>
        <div className="max-w-[720px] mx-auto px-6 md:px-14 py-20" style={{ paddingTop: 80 }}>
          <span className="pill mb-4 inline-flex">
            <span className="pill-dot" /> 02 · Sign up · 30 seconds
          </span>
          <h1 className="font-medium mt-5 mb-4" style={{ fontSize: 'clamp(28px, 3.4vw, 44px)', lineHeight: 1.04, letterSpacing: '-0.03em' }}>
            Get your CMP, <span className="grad-text">passwordless</span>.
          </h1>
          <p className="text-[15px] leading-[1.55] mb-9 max-w-[560px]" style={{ color: 'rgba(13,11,31,0.7)' }}>
            We&apos;ll send a sign-in link to your inbox. No password to remember, no email verification step. The link itself is the verification.
          </p>

          <form onSubmit={onSubmit} className="max-w-[460px]">
            <label className="field">
              <span className="field-label">Work email</span>
              <input
                type="email"
                required
                placeholder="you@yourcompany.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={submitting}
              />
            </label>

            {error && (
              <div
                className="mb-5 p-3 text-[13px]"
                style={{
                  background: 'rgba(232,81,122,0.1)',
                  border: '1px solid var(--flag)',
                  color: 'var(--flag)',
                  borderRadius: 'var(--radius)',
                }}
              >
                {error}
              </div>
            )}

            <button type="submit" className="btn" disabled={submitting}>
              <span>{submitting ? 'Sending link…' : 'Send me the sign-in link'}</span>
              {!submitting && <span className="slash">/</span>}
            </button>

            <p className="mt-6 text-[12px] leading-[1.55]" style={{ color: 'var(--muted-ink)' }}>
              By continuing you accept the <a href="https://app.wedpo.com/license-agreement" className="underline" style={{ color: 'var(--ink)' }}>License Agreement</a> and <a href="https://wedpo.com/privacy-policy" className="underline" style={{ color: 'var(--ink)' }}>Privacy Policy</a>. We use the email solely to deliver the sign-in link (GDPR Art. 6(1)(b)).
            </p>
          </form>
        </div>
      </section>
    </Shell>
  );
}
